import { Component, Input } from '@angular/core';
import { Column } from '../../store/view/types';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { GridService } from '../../service/grid.service';

@Component({
  selector: 'app-offcanvas-content',
  standalone: false,
  templateUrl: './offcanvas-content.component.html',
  styleUrl: './offcanvas-content.component.scss',
})
export class OffcanvasContentComponent {
  //@Input useful for programmatic initialization component.title = 'truc'
  @Input() title = '';
  @Input() fields: Column[] = [];
  @Input() row: any;

  constructor(
    private readonly activeOffcanvas: NgbActiveOffcanvas,
    private readonly gridService: GridService,
  ) {}

  protected format(field: Column) {
    return this.gridService.formatValue(field.type, this.row?.[field.name]);
  }

  protected onClickClose() {
    this.activeOffcanvas.dismiss();
  }
}
